<template>
    <div class="row my-2">
					<div class="search_option">
						<div class="search_option__sort">
							<div class="search_option__sort_item"><label>メーカー名</label>
                <i @click="sortFiltered(1)" class="fas fa-caret-up"></i>
                <i @click="sortFiltered(2)" class="fas fa-caret-down"></i>
              </div>
							<div class="search_option__sort_item"><label>型式</label>
                <i @click="sortFiltered(3)" class="fas fa-caret-up"></i>
                <i @click="sortFiltered(4)" class="fas fa-caret-down"></i>
              </div>
							<div @click="sortFiltered(5)" class="search_option__sort_link"><a>商品カテゴリ順</a></div>
							<div class="search_option__sort_chckbox"><label><input type="checkbox">チャーター品も含める</label></div>
						</div>
						<!-- nav>
							<a href="#" ><i class="fas fa-angle-double-left"></i></a
							><a href="#" class="pagenate_page is-active">1</a><a href="#" >2</a
							><a href="#" class="pagenate_page">3</a
							><a href="#" class="pagenate_next"><i class="fas fa-angle-double-right"></i></a>
            </nav -->
      <div v-if="filtered.length > perPage">
      <paginate
        :page-count="pageCount"
        :page-range="3"
        :margin-pages="2"
        :click-handler="clickCallback"
        :prev-text="'<<'"
        :next-text="'>>'"
        :container-class="'pagination'"
        :page-class="'page-item'"  
      >
      </paginate>
					</div>
      </div>
    <ul class="list_product">
      <div v-for="product in getItems(filtered)" v-bind:key="product.id">
        <div v-if="!product.isCharter">            
          <li>  
            <router-link :to="{ name: 'single', params: {Id: product.id}}" class="product_status">    
              <div>
                <img :src="kenki_image_path + product.product.product_code + '-01.jpg'" :alt="product.product.title" @error="onImageError">
              </div>
              <dl>
                <dt>{{product.product.title}}</dt>
                <dd><label>メーカー</label><span>{{product.product.manufacture_name}}</span></dd>
                <dd><label>呼称</label><span>{{product.product.product_short_name}}</span></dd>
                <dd><label>型式</label><span>{{product.product.product_model_name}}</span></dd>
                <dd><label>商品コード</label><span>{{product.product.product_name}}</span></dd>
								<dd class="list_product__comp"></dd>
							</dl>
							<label class="list_product__netis" v-if="product.product.netis">NETIS</label>
            </router-link>
          </li>
        </div>
        <div v-else>
          <li>  
            <router-link :to="{ name: 'single', params: {Id: product.id}}" class="product_status">    
              <div>
                <img :src="kenki_image_path + product.product.product_code + '-01.jpg'" :alt="product.product.title" @error="onImageError">
              </div>
              <dl>
                <dt>{{product.product.title}}</dt>
                <dd><label>メーカー</label><span>{{product.product.manufacture_name}}</span></dd>
                <dd><label>呼称</label><span>{{product.product.product_short_name}}</span></dd>
                <dd><label>型式</label><span>{{product.product.product_model_name}}</span></dd>
                <dd><label>商品コード</label><span>{{product.product.product_name}}</span></dd>
								<dd class="list_product__comp">KL/DD/SA/CL/OT</dd>
							</dl>
							<label class="list_product__netis" v-if="product.product.netis">NETIS</label>
            </router-link>
          </li>
        </div>
      </div>
    </ul>
      <!-- pagination -->
      <div v-if="filtered.length > perPage">
      <div class="text-center">
      <paginate
        :page-count="pageCount"
        :page-range="3"
        :margin-pages="2"
        :click-handler="clickCallback"
        :prev-text="'<'"
        :next-text="'>'"
        :container-class="'pagination'"
        :page-class="'page-item'"  
      >
      </paginate>
      </div>
      </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        filtered: [],
        perPage: 20,
        currentPage: 1,
        pageCount: 0,
        kenki_image_path: process.env.VUE_APP_KENKI_IMAGE_PATH,
        noImage: process.env.BASE_URL + '_img/noimage.png'
      }
    },
    props: {
      categorySet: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    methods: {
      onImageError: function (event) {
        event.target.onerror = null
        event.target.src = this.noImage
      },
      setParams: function (searchClass, comId = 1, key = '', id = '', name = ''){
        // key -- search box
        // id --- category_id
        // name - sub_categories ex) tag 
        var param = {};
        if(id){
          param = {
            'limit': 100,
            [searchClass]: {
                'category_id': id,
                'company_id': comId
            }
          }
        }
        else if(name){
          param = {
            'limit': 100, 
            [searchClass]: {
              'sub_categories': {
                'name': name
              },
              'company_id': comId
            }
          }          
        }
        else{
          param = {
            'limit': 100, 
            [searchClass]: {
              'product': {
                '$or': {
                  'title': key, 'manufacture_name': key, 'product_name': key, 'product_short_name': key, 'product_code': key, 'product_model_name': key
                }
              },
              'company_id': comId
            }
          }
        }
        return param 
      },
      findCategoryName: function (id) {
        if (!id || !this.categorySet) return ''
        var targetId = Number(id)
        for(var i=0;i<this.categorySet.length;i++){
          if(Number(this.categorySet[i].id) === targetId) return this.categorySet[i].name
          for(var j=0;j<this.categorySet[i].child.length;j++){
            if(Number(this.categorySet[i].child[j].id) === targetId) return this.categorySet[i].child[j].name
            for(var k=0;k<this.categorySet[i].child[j].child.length;k++){
              if(Number(this.categorySet[i].child[j].child[k].id) === targetId) return this.categorySet[i].child[j].child[k].name
            }
          }
        }
        return ''
      },
      syncPageContext: function () {
        var title = '商品一覧'
        if(this.$route.params.Keyword){
          title = '検索: ' + this.$route.params.Keyword
        }else if(this.$route.params.Name){
          title = this.$route.params.Name
        }else if(this.$route.params.Id){
          title = this.findCategoryName(this.$route.params.Id) || '商品一覧'
        }
        var app = this.$root || this.$parent
        if (app) {
          app.category_id = this.$route.params.Id || null
          app.active_page_title = title
          if (app.setPageMeta) {
            app.setPageMeta(title)
          }
        }
      },
      //for pagination
      clickCallback: function (pageNum) {
        this.currentPage = Number(pageNum)
      },
      getItems: function (filtered) {
        var current = this.currentPage * this.perPage
        var start = current - this.perPage
        return filtered.slice(start, current)
      },
      //for sort
      sortFiltered: function (sortKey = 0) {
        // sortKey 0: no sort, 1: makerName asc, 2: makerName desc, 3: 型式 asc, 4: 型式 desc, 5: カテゴリ順
        function compare_1(a, b){
          var r = 0
          if(a.product.manufacture_name > b.product.manufacture_name){ r = 1 }
          else if(a.product.manufacture_name < b.product.manufacture_name){ r = -1 }
          return r
        }
        function compare_2(a, b){
          var r = 0
          if(a.product.manufacture_name > b.product.manufacture_name){ r = 1 }
          else if(a.product.manufacture_name < b.product.manufacture_name){ r = -1 }
          return (r * -1)
        }
        function compare_3(a, b){
          var r = 0
          if(a.product.product_model_name > b.product.product_model_name){ r = 1 }
          else if(a.product.product_model_name < b.product.product_model_name){ r = -1 }
          return r
        }
        function compare_4(a, b){
          var r = 0
          if(a.product.product_model_name > b.product.product_model_name){ r = 1 }
          else if(a.product.product_model_name < b.product.product_model_name){ r = -1 }
          return (r * -1)
        }
        function compare_5(a, b){
          var r = 0
          if(a.product.title > b.product.title){ r = 1 }
          else if(a.product.title < b.product.title){ r = -1 }
          return r
        }
        if(sortKey === 1){
          this.filtered.sort(compare_1)
        }else if(sortKey === 2){
          this.filtered.sort(compare_2)
        }else if(sortKey === 3){
          this.filtered.sort(compare_3)
        }else if(sortKey === 4){
          this.filtered.sort(compare_4)
        }else if(sortKey === 5){
          this.filtered.sort(compare_5)
        }
      },
      filterProducts: function () {
        var url = process.env.VUE_APP_URL + '/stock_products/search';
        var myToken = process.env.VUE_APP_TOKEN;
        var myComId = process.env.VUE_APP_COMPANY_ID;
        var myKey = this.$route.params.Keyword;
        var myId = this.$route.params.Id;
        var myName = this.$route.params.Name;
        var param = {};
        param = this.setParams('stock_product', myComId, myKey, myId, myName)
        fetch(url, {
          method: "POST",
          mode: "cors",
          headers:  {
            'Content-Type': 'application/json',
            'Authorization': `Token ${myToken}`
          },
          body: JSON.stringify(param)
        })
        .then(res => {
          return res.json()
        })
        .then(data => {
          for(var i=0;i<data.length;i++){
            data[i]['isCharter'] = false
          }
          this.filtered = data
          this.pageCount = Math.ceil(this.filtered.length / this.perPage)
        })
        .catch(e => console.error(e))
        
        //add chartered_stock_product
        url = process.env.VUE_APP_URL + '/chartered_stock_products/search';
        param = this.setParams('stock_product', myComId, myKey, myId, myName)
        fetch(url, {
          method: "POST",
          mode: "cors",
          headers:  {
            'Content-Type': 'application/json',
            'Authorization': `Token ${myToken}`
          },
          body: JSON.stringify(param)
        })
        .then(res => {
          return res.json()
        })
        .then(data => {
          for(var i=0;i<data.length;i++){
            data[i]['isCharter'] = true
          }
          this.filtered = this.filtered.concat(data)
          this.pageCount = Math.ceil(this.filtered.length / this.perPage)
        })
        .catch(e => console.error(e))
      }
    },
    mounted () {
      this.filterProducts()
      this.syncPageContext()
    },
    watch: {
      '$route': function () {
        this.filterProducts()
        this.syncPageContext()
      },
      categorySet: function () {
        this.syncPageContext()
      },
    },
    beforeRouteUpdate(to, from, next){
      next()
      this.syncPageContext()
    }
  }
</script>
<style>
  .text-center {
    text-align: center;
  }
  .pagination {
    text-align: right;
    margin-bottom: 30px;
  }
  ul.pagination li {display: inline;}
  ul.pagination li a{
    display: inline-block;
    border: 1px solid #999999;
    min-width: 26px;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    color: #00b9ef;
    padding: 5px;
    margin-left: 2px;
    transition: .5s;
  }
  ul.pagination li a.active, a:hover {
    background-color: #00b9ef;
    color: #FFFFFF;
  }
  /*
  ul.pagination {
    display: inline-block;
    padding: 0;
    margin: 0;
  }

  ul.pagination li {display: inline;}

  ul.pagination li a {
    color: black;
    float: left;
    padding: 8px 16px;
    text-decoration: none;
  }

  ul.pagination li a.active {
    background-color: #4CAF50;
    color: white;
  }
  ul.pagination li a:hover:not(.active) {background-color: #ddd;}
  */
</style>
